import { Inject } from '@angular/core';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FileUpload, FileUploadService } from 'src/app/services/file-upload.service';
import { ActivatedRoute } from '@angular/router';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-filedownload',
  templateUrl: './filedownload.component.html',
  styleUrls: ['./filedownload.component.scss']
})

export class FiledownloadComponent implements OnInit {

  @Input() file: FileUpload;
  @Output() downloadEvent = new EventEmitter<FileUpload>();

  downloadUrl: string = "";
  fileUploadId: number;
  fileUpload: FileUpload;
  fileName: string;

  constructor(@Inject('BASE_URL') private baseUrl: string,
    private fileUploadService: FileUploadService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.fileUploadId = parseInt(this.route.snapshot.paramMap.get('fileUploadId'));
    this.downloadFile();
  }

  downloadFile() {
    this.fileUploadService.getFileNameById(this.fileUploadId).subscribe((response: string) => {
      this.fileName = response;
      this.fileUploadService.downloadFile(this.fileUploadId)
        .then(
          (result: Blob) => { saveAs(result, this.fileName) },
          (error: Blob) => { return false;}
        )
        .then(x => window.setTimeout(function () { window.close(); }, 2000))
    });


    
  }
}
